import { combineReducers } from "@reduxjs/toolkit";
import userSlice from "./userSlice";

const Slices = combineReducers({
  User: userSlice,

});
export default Slices;
